<ng-container></ng-container>
@if (loadContent) {
    <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
}